// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"a3c720bd","485":"97d2b476","514":"2bbafce5","529":"60d405f2","871":"c67582f3"}[chunkId] + ".chunk.js";
};